import React from 'react';
import { useAuth } from '@hooks/useAuth.js';
import Spinner from '../common/spinner/spinner.jsx';

export const AuthProvider = ({ children }) => {
    const isLoading = useAuth();

    return (
      <>
          {isLoading ? <Spinner fullScreen spinning/> : children }
      </>
    );
};
